export const unitsBundle = {
  emptyMessage: {
    ko: {
      title: "동·호수를 검색해주세요.",
      description: "세대를 선택하면 사용량 정보를 확인할 수 있습니다."
    },
    en: {
      title: "Please search for a building and unit number.",
      description: "Select a household to view its usage information."
    },
    es: {
      title: "Busca un edificio y un número de unidad.",
      description: "Selecciona una vivienda para consultar su información de consumo."
    }
  }
}
